import React from 'react'
import './Icon.scss'
const rootClassName = 'icon-component'

export const PlayIcon = () => {
  return (
    <svg
      className={rootClassName}
      viewBox='0 0 20 20'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10 0C15.5231 0 20 4.47686 20 10C20 15.5231 15.5231 20 10 20C4.47686 20 0 15.5231 0 10C0 4.47686 4.47686 0 10 0ZM10 1C5.02914 1 1 5.02914 1 10C1 14.9709 5.02914 19 10 19C14.9709 19 19 14.9709 19 10C19 5.02914 14.9709 1 10 1ZM6.6851 6.4063V13.5933C6.6851 14.2022 7.34947 14.5771 7.87068 14.2638L13.7781 10.6674C14.2798 10.3653 14.2798 9.63533 13.776 9.33197L7.87311 5.73822C7.34989 5.42373 6.6851 5.79693 6.6851 6.4063ZM12.9508 10.0003L7.6851 13.2061V6.7945L12.9508 10.0003Z'
      />
    </svg>
  )
}
